export default __webpack_public_path__ + "static/media/SpiffyHomepage.340b598f.png";